import { useSelector } from 'react-redux';
import MiniCard from './MiniCard';
import StatusDropdown from './StatusDropdown';
import Trans from '@/components/shared/Trans';
import translations from '../Dashboard.trans.json';
import { useTrackMiniCards } from '../customHooks/useTrackDashboard';

function scrollInto(selector, offset = 16) {
  const headerHeight = 56;
  const fixedFiltersHeights = 72;
  const totalOffset = headerHeight + fixedFiltersHeights + offset;

  const element = document.querySelector(selector);
  if (element) {
    const y =
      element.getBoundingClientRect().top + window.scrollY - totalOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

export function ContactsMiniCard() {
  const { miniCards } = useSelector((state) => state.DashboardSlice);
  const track = useTrackMiniCards();

  return (
    <MiniCard
      title={Trans(translations, 'ActiveContacts')}
      value={miniCards.contactsValue}
      onClick={() => {
        scrollInto('#overview-contacts');
        track.contacts();
      }}
      loading={miniCards.loading}
    />
  );
}

export function PropertiesMiniCard() {
  const { miniCards } = useSelector((state) => state.DashboardSlice);
  const track = useTrackMiniCards();

  return (
    <MiniCard
      title={Trans(translations, 'Properties')}
      value={miniCards.propertiesValue}
      onClick={() => {
        scrollInto('#overview-properties');
        track.properties();
      }}
      loading={miniCards.loading}
    >
      <StatusDropdown />
    </MiniCard>
  );
}

export function DevelopmentsMiniCard() {
  const { miniCards } = useSelector((state) => state.DashboardSlice);
  const track = useTrackMiniCards();

  return (
    <MiniCard
      title={Trans(translations, 'AvailableDevelopments')}
      value={miniCards.developmentsValue}
      onClick={() => {
        scrollInto('#overview-developments');
        track.developments();
      }}
      loading={miniCards.loading}
    />
  );
}
